export const CUSTOMER_TYRES_SLIDER_RANGE = 10;